import { Link } from "react-router-dom";
import InfiniteMenu from "../components/InfiniteMenu";
import "./TestingPageTwo.css";

const PLANET_TEXTURE_BASE =
  "https://cdn.jsdelivr.net/gh/mrdoob/three.js@r162/examples/textures/planets";

const ORBITAL_PLANETS = [
  {
    id: "mercury",
    image: `${PLANET_TEXTURE_BASE}/mercury.jpg`,
    color: "#9aa3b2",
  },
  {
    id: "venus",
    image: `${PLANET_TEXTURE_BASE}/venus.jpg`,
    color: "#ff9c42",
  },
  {
    id: "earth",
    image: `${PLANET_TEXTURE_BASE}/earth_atmos_2048.jpg`,
    color: "#2f7bff",
  },
  {
    id: "mars",
    image: `${PLANET_TEXTURE_BASE}/mars_1k_color.jpg`,
    color: "#ff604a",
  },
  {
    id: "jupiter",
    image: `${PLANET_TEXTURE_BASE}/jupiter.jpg`,
    color: "#f6b36a",
  },
  {
    id: "saturn",
    image: `${PLANET_TEXTURE_BASE}/saturn.jpg`,
    color: "#f1d08a",
  },
  {
    id: "uranus",
    image: `${PLANET_TEXTURE_BASE}/uranus.jpg`,
    color: "#4bd4ff",
  },
  {
    id: "pluto",
    image: `${PLANET_TEXTURE_BASE}/pluto.jpg`,
    color: "#b68cff",
  },
];

export default function TestingPageTwo() {
  return (
    <div className="testing-space">
      <header className="testing-space__header">
        <Link to="/" className="testing-space__logo">
          DYLAN CHEN ZHEN
        </Link>
        <nav className="testing-space__nav">
          <span className="testing-space__nav-link testing-space__nav-link--disabled">
            Projects
          </span>
          <Link to="/testing" className="testing-space__nav-link">
            Testing 1
          </Link>
          <Link to="/testing-3" className="testing-space__nav-link">
            Testing 3
          </Link>
          <Link to="/testing-4" className="testing-space__nav-link">
            Testing 4
          </Link>
          <Link to="/testing-5" className="testing-space__nav-link">
            Testing 5
          </Link>
          <Link to="/about" className="testing-space__nav-link">
            About
          </Link>
        </nav>
      </header>

      <div className="testing-space__intro">
        <span className="testing-space__eyebrow">Teseting 2</span>
        <h1 className="testing-space__title">Orbital Space Menu</h1>
      </div>

      <div className="testing-space__menu">
        <InfiniteMenu items={ORBITAL_PLANETS} scale={1.05} />
      </div>
    </div>
  );
}
